module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.11eabca.ttf";


//////////////////
// WEBPACK FOOTER
// ./autocomplete-component/dist/src/fonts/Roboto-Regular.ttf
// module id = Ijjq
// module chunks = 1